import React from 'react'
import MotorsContainer from './MotorsContainer'

const Motors = () => <MotorsContainer data-test="component-motors" />

export default Motors
